export const DEBOUNCE_TIMEOUT = 150;

export const TYPE_TO_ICON_MAP = {
  location: "globe",
  entity_value: "attribute-search",
  default: "search",
};

export const ENTITY_TO_ICON_MAP = {
  organizations: "company",
  default: "entity",
};

export const AUTOCOMPLETE_INITIAL_SUGGESTIONS = [
  {
    matched: "PLACEHOLDER",
    display: "PLACEHOLDER",
    current_search: true,
    starts_with_search: null,
    special_cases_type: "current_search",
    type: "special_cases"
  },
  {
    matched: "PLACEHOLDER*",
    display: "PLACEHOLDER*",
    current_search: null,
    starts_with_search: true,
    special_cases_type: "starts_with_search",
    type: "special_cases"
  },
  {
    matched: "#source(PLACEHOLDER)",
    display: "PLACEHOLDER",
    type: "source_doc_search"
  },
];

export const UNIQUE_ICON_TYPE_SUGGESTIONS = [
  {
    type: "entity",
    entity_type: "organizations",
    display: "Pfizer",
    url: "/sales_assistant/organizations/4fb6d31a5825b9112d01ba15"
  },
  {
    type: "entity",
    entity_type: "other_entity",
    display: "Pfizerquine",
    url: "/sales_assistant/therapies/4ffa3562f758862fb1003e48"
  },
  {
    type: "location",
    display: "New Delhi, Delhi, India",
  },
  {
    type: "entity_value",
    display: "Organizations with 400 employees or less",
  },
  {
    type: "alias_search",
    display: "All Manufacturing Scale Up Activity",
  },
  {
    type: "other_type",
    display: "pfiz",
  },
];
